import { render, staticRenderFns } from "./TakipInfo.vue?vue&type=template&id=2ad93d02"
import script from "./TakipInfo.vue?vue&type=script&lang=ts"
export * from "./TakipInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports